"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HomeownerCards() {
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";

  const cards = [
    {
      titleKey: "blog.codes.homeownerBuying",
      textEn: "Every product MUST show a valid NOA number on the frame label or packaging. Ask your contractor for the NOA certificate before any deposit. Cross-check the number on the Miami-Dade PCA database.",
      textEs: "Todo producto DEBE mostrar un número de NOA válido en la etiqueta del marco o empaque. Solicite el certificado NOA a su contratista antes de cualquier depósito. Verifique el número en la base de datos PCA de Miami-Dade.",
    },
    {
      titleKey: "blog.codes.homeownerHiring",
      textEn: "Verify the contractor's Florida state license (check myfloridalicense.com) and confirm their Miami-Dade permit number is active. Unlicensed contractors cannot pull permits, and their work voids your warranty.",
      textEs: "Verifique la licencia estatal de Florida del contratista (en myfloridalicense.com) y confirme que su número de permiso de Miami-Dade esté activo. Los contratistas sin licencia no pueden obtener permisos y su trabajo anula su garantía.",
    },
    {
      titleKey: "blog.codes.homeownerInsurance",
      textEn: "Without NOA-stamped windows, no wind mitigation discount applies. Insurers require photographic proof of NOA labels during re-inspection. Non-compliant installations can void coverage entirely.",
      textEs: "Sin ventanas con sello NOA, no aplica ningún descuento de mitigación de viento. Los aseguradores requieren prueba fotográfica de etiquetas NOA durante la re-inspección. Las instalaciones no conformes pueden anular la cobertura por completo.",
    },
  ];

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-[#064e3b] mb-6 text-center">
        {t("blog.codes.homeownerHeading")}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {cards.map((c) => (
          <div key={c.titleKey} className="bg-white border-t-4 border-[#064e3b] rounded-lg p-6 shadow-sm">
            <h3 className="text-xl font-bold text-[#064e3b]">{t(c.titleKey)}</h3>
            <p className="text-sm text-gray-600 mt-3 leading-relaxed">{isEs ? c.textEs : c.textEn}</p>
          </div>
        ))}
      </div>
    </section>
  );
}